var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "main_form" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              attrs: { inline: true, model: _vm.queryModel, size: "small" }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "search_form_item", attrs: { prop: "userId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("m.live_ID"), clearable: "" },
                    model: {
                      value: _vm.queryModel.userId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.queryModel,
                          "userId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "queryModel.userId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "search_form_item", attrs: { prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("m.audit_status"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.queryModel.status,
                        callback: function($$v) {
                          _vm.$set(_vm.queryModel, "status", $$v)
                        },
                        expression: "queryModel.status"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: 0, label: _vm.$t("m.pending_review") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          value: 1,
                          label: _vm.$t("m.pending_HQ_review")
                        }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 2, label: _vm.$t("m.not_approved") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 4, label: _vm.$t("m.not_approved_HQ") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 11, label: _vm.$t("m.withdrawn") }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.apply_time")
                        },
                        model: {
                          value: _vm.queryModel.applyStartTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "applyStartTime", $$v)
                          },
                          expression: "queryModel.applyStartTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { staticClass: "coldiv", attrs: { span: 1 } }, [
                    _vm._v("~")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.apply_time")
                        },
                        model: {
                          value: _vm.queryModel.applyEndTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "applyEndTime", $$v)
                          },
                          expression: "queryModel.applyEndTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-wrapper" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onQueryBtnClick }
                },
                [_vm._v(_vm._s(_vm.$t("m.search")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: { click: _vm.resetForm }
                },
                [_vm._v(_vm._s(_vm.$t("m.reset")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main_table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table"
                }
              ],
              ref: "tableOrder",
              staticStyle: { width: "100%", "margin-bottom": "10px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "row-class-name": _vm.tableRowClassName,
                "element-loading-text": "",
                "element-loading-spinner": "el-icon-loading"
              }
            },
            [
              _c("el-table-column", { attrs: { prop: "id", label: "ID" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "userId", label: _vm.$t("m.live_ID") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userName",
                  label: _vm.$t("m.sereamer_nickname")
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "birthday", label: _vm.$t("m.birth") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "livePosterList",
                  label: _vm.$t("m.live_record")
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return scope.row.livePosterList &&
                          scope.row.livePosterList.length > 0 &&
                          scope.row.livePosterList[0].url
                          ? [
                              _c("img", {
                                staticClass: "img-thumb",
                                attrs: { src: scope.row.livePosterList[0].url },
                                on: {
                                  click: function($event) {
                                    return _vm.showVideoPreviewDialog(
                                      scope.row.liveList
                                    )
                                  }
                                }
                              })
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "videoPosterList",
                  label: _vm.$t("m.other_video_materials")
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return scope.row.videoPosterList &&
                          scope.row.videoPosterList.length > 0 &&
                          scope.row.videoPosterList[0].url
                          ? [
                              _c("img", {
                                staticClass: "img-thumb",
                                attrs: {
                                  src: scope.row.videoPosterList[0].url
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showVideoPreviewDialog(
                                      scope.row.videoList
                                    )
                                  }
                                }
                              })
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "email",
                  label: _vm.$t("m.email"),
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.emailState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "emailState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.emailState === true
                          ? _c("span", [_vm._v(_vm._s(scope.row.email))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "whatsApp", label: "WhatsApp" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.whatsappState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "whatsappState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.whatsappState === true
                          ? _c("span", [_vm._v(_vm._s(scope.row.whatsApp))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "faceBook", label: "Facebook" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.facebookState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "facebookState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.facebookState === true
                          ? _c("span", [_vm._v(_vm._s(scope.row.faceBook))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "instagram", label: "Instagram" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.instagramState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "instagramState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.instagramState === true
                          ? _c("span", [_vm._v(_vm._s(scope.row.instagram))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: _vm.$t("m.phone") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.phoneState === false
                          ? _c("img", {
                              attrs: {
                                width: "24",
                                src: require("../../assets/search.png")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getDetailInfo(
                                    scope.row,
                                    "phoneState"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.phoneState === true
                          ? _c("span", { staticClass: "direction_ltr" }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.areaCode
                                    ? "+" + scope.row.areaCode
                                    : ""
                                ) + _vm._s(scope.row.phone)
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "lang", label: _vm.$t("m.mastery_lang") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("langFilt")(scope.row.lang)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: _vm.$t("m.audit_status"),
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("m.pending_review")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("m.pending_HQ_review")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 2
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("m.not_approved")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 4
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("m.not_approved_HQ")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 11
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("m.withdrawn")))]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "refuseReason",
                  label: _vm.$t("m.rejection_reason"),
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: _vm.$t("m.apply_time") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t("m.oper"), width: "100" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return scope.row.status === 0
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.passApplication(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("m.pass")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.rejectCooperation(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("m.refused")))]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pager.page,
              "page-sizes": [10, 20, 30, 100, 300, 500],
              "page-size": _vm.pager.limit,
              small: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pager.total,
              "pager-count": 5
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.onCurrentPageChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialog.show,
            title: _vm.$t("m.reject_streamer_join_agency_apply"),
            "close-on-click-modal": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog, "show", $event)
            },
            close: function($event) {
              return _vm.$refs.editForm.resetFields()
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              attrs: {
                model: _vm.dialog.model,
                rules: _vm.dialog.rules,
                size: "small",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "20px" } },
                [
                  _c("el-button", {
                    staticStyle: { padding: "2px", "margin-right": "5px" },
                    attrs: { type: "danger", icon: "el-icon-close", circle: "" }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("m.reject_streamer_join_agency", {
                          msg_ss1: _vm.dialog.model.userName,
                          msg_ss2: _vm.guildName
                        })
                      )
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "refuseReason",
                    label: _vm.$t("m.rejection_reason") + ":"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t("m.rejection_reason"),
                      maxlength: "50"
                    },
                    model: {
                      value: _vm.dialog.model.refuseReason,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.dialog.model,
                          "refuseReason",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "dialog.model.refuseReason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialog.show = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("m.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.dialog.btnLoading
                  },
                  on: { click: _vm.doEdit }
                },
                [_vm._v(_vm._s(_vm.$t("m.Confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialog.picture.show,
            title: _vm.$t("m.preview") + ":",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog.picture, "show", $event)
            },
            close: _vm.resetInfoForm
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialog.picture.loading,
                  expression: "dialog.picture.loading"
                }
              ]
            },
            [
              _c(
                "el-carousel",
                {
                  attrs: {
                    autoplay: false,
                    "indicator-position": "none",
                    arrow: "always"
                  }
                },
                _vm._l(_vm.dialog.picture.fileList, function(item, index) {
                  return _c("el-carousel-item", { key: index }, [
                    item.type === 2 || item.type === 4 || item.type === 3
                      ? _c("img", {
                          staticClass: "img-preview",
                          attrs: { src: item.url }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    item.type === 0 || item.type === 1
                      ? _c("video", {
                          staticClass: "img-preview",
                          attrs: {
                            src: item.url,
                            controls: "controls",
                            type: "video/mp4"
                          }
                        })
                      : _vm._e()
                  ])
                }),
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7caab065", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7caab065","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/anchor/joinGuildManagementPage.vue
// module id = null
// module chunks = 